import { useEffect, useRef } from 'react';

// Things the Android back button should close before it leaves a page — a
// drawer, a hand-built side panel. Newest first, so the panel opened last is
// the one that closes. A handler returns true when it handled the press.
const handlers = [];

export function runBackHandlers() {
  for (let i = handlers.length - 1; i >= 0; i -= 1) {
    if (handlers[i].current?.()) return true;
  }
  return false;
}

/**
 * Close something on Android back while `active`. A no-op in a browser — the
 * hook only registers; nothing calls it unless NativeShell is mounted.
 */
export function useNativeBack(active, onBack) {
  const ref = useRef(null);
  ref.current = () => {
    if (!active) return false;
    onBack();
    return true;
  };
  useEffect(() => {
    handlers.push(ref);
    return () => {
      const i = handlers.indexOf(ref);
      if (i >= 0) handlers.splice(i, 1);
    };
  }, []);
}
